import defaultsDeep from "lodash/defaultsDeep";
import { alchemyBrand, alchemyBrandContrast, alchemyDark, alchemyDarkContrast, alchemyLight, alchemyLightContrast, alchemyPanel, alchemyPanelContrast } from "./color-schemes";
import { typography } from "./typography";
import { BREAKPOINTS, NAMESPACE } from "./constants";
import { visualizationAccessibleThemeOverrides } from "./visualization-palettes";
export const theme = {
    name: "alchemy",
    features: {
        highContrast: false,
        enhancedVisualizationContrast: false
    },
    defaults: {
        colorScheme: "alchemyLight",
        palette: "structural",
        accentPalette: "interactiveConstructive"
    },
    breakpoints: BREAKPOINTS,
    typography,
    colorSchemes: {
        alchemyLight,
        alchemyDark,
        alchemyPanel,
        alchemyBrand
    }
};
export const highContrastTheme = defaultsDeep({}, visualizationAccessibleThemeOverrides, {
    ...theme,
    features: {
        highContrast: true
    },
    name: "alchemyContrast",
    colorSchemes: {
        alchemyLight: alchemyLightContrast,
        alchemyDark: alchemyDarkContrast,
        alchemyPanel: alchemyPanelContrast,
        alchemyBrand: alchemyBrandContrast
    }
});
export const namespacedTheme = {
    [NAMESPACE]: theme
};
